import { Component, inject } from '@angular/core';
import { FooterNavItemComponent } from './nav-item/nav-item.component';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { LayoutService } from 'src/app/services/layout/layout.service';
import { Path, RoutePath } from 'src/app/shared/route';

@Component({
  templateUrl: './footer.component.html',
  standalone: true,
  selector: 'app-footer',
  imports: [FooterNavItemComponent, NgIf, TranslatePipe],
})
export class FooterComponent {
  termRoute = RoutePath.getPath(Path['terms-and-conditions']).fullPath;
  privacyRoute = RoutePath.getPath(Path['privacy-policy']).fullPath;
  blogRoute = RoutePath.getPath(Path.blog).fullPath;
  aboutUsRoute = RoutePath.getPath(Path['about-us']).fullPath;
  contactUsRoute = RoutePath.getPath(Path['contact-us']).fullPath;
  helpRoute = RoutePath.getPath(Path.help).fullPath;

  currentYear = new Date().getFullYear();

  layoutService = inject(LayoutService);

  get showFooter() {
    return this.layoutService.showFooter;
  }
}
